import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';
import { isUserMultiTenant } from "../../../swzutils/UserPermissionsUtil";
import TenantSelector from './TenantSelector';
import { useAppSelector } from "../../../store";
import { loggedInUserSelector } from "../../../store/slice/auth";
const AppHeader = () => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    return (_jsxs("div", { className: "app-header-inner bg-color-light", children: [_jsx("div", { className: "header-left", children: _jsx(HeaderLeft, {}) }), isUserMultiTenant(loggedInUser) &&
                _jsx(TenantSelector, {}), _jsx("div", { className: "header-right", children: _jsx(HeaderRight, {}) })] }));
};
export default AppHeader;
